import axios from "axios"
import { queryFixer } from "common/utils/utils"

export default class EntidadBancariaService {
  getEntidadesBancarias({ queryState }: $TSMigrationFixMe) {
    const query = queryFixer(`/EntidadBancaria/by-filters`, queryState)
    return axios.get(query)
  }

  getEntidadBancariaByIban(iban: $TSMigrationFixMe) {
    return axios.get(`/EntidadBancaria/by-iban/${iban}`)
  }
}
